import React from 'react';
import { Grid } from '@material-ui/core';
import MDXParser from '../mdxParser';
import Container from '@material-ui/core/Container';

import Img from '../wrappedImage';
import { useStaticQuery, graphql } from 'gatsby';

// Content
import AddressingKenyaPartOne from '../../sections/NexusFeatureTwo/AddressingKenyaOne';
import AddressingKenyaPartTwo from '../../sections/NexusFeatureTwo/AddressingKenyaTwo';
import AddressingKenyaPartThree from '../../sections/NexusFeatureTwo/AddressingKenyaThree';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: '#b5dded',
    },
    root: {
      padding: '60px 0',
    },
    rootDetail: {},
    text: {
      padding: '0px 20px',
      display: 'flex',
      backgroundColor: 'transparent',
      flexDirection: 'column',
      boxShadow: 'none',
      borderRadius: '0px',
    },
    image: {
      width: '100%',
      height: 'auto',

    },
    imageContainer: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: 'none',
    },
  }),
);

type Props = { children: React.ReactNode; image: string };

const NexusTwoSection = () => {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query {
      kenya: file(relativePath: { eq: "kenya.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Container maxWidth={false} disableGutters={true} className={classes.container}>
      <Container>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <MDXParser>
                <AddressingKenyaPartOne />
              </MDXParser>
            </Grid>
            <Grid item xs={12} md={12}>
              <Img fluid={data.kenya.childImageSharp.fluid} className={classes.image} alt="Image" copyText='WFP/Martin Karimi' />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDXParser>
                <AddressingKenyaPartTwo />
              </MDXParser>
            </Grid>

            <Grid item xs={12} md={6}>
              <MDXParser>
                <AddressingKenyaPartThree />
              </MDXParser>
            </Grid>

          </Grid>
        </div>
      </Container>
    </Container>
  );
};

export default NexusTwoSection;
